export const CANVAS_ANIMATION_RATE = 1.2;

export function scaleAnimationDelta(delta) {
  const safeDelta = Number(delta);
  return Number.isFinite(safeDelta) && safeDelta > 0
    ? safeDelta * CANVAS_ANIMATION_RATE
    : 0;
}
